module.exports = __webpack_public_path__ + "assets/img/fontSize.56a176da.png";